import { render, staticRenderFns } from "./teamBlock.vue?vue&type=template&id=5ffb75b8&scoped=true"
import script from "./teamBlock.vue?vue&type=script&lang=js"
export * from "./teamBlock.vue?vue&type=script&lang=js"
import style0 from "./teamBlock.vue?vue&type=style&index=0&id=5ffb75b8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffb75b8",
  null
  
)

export default component.exports